// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__w6Pjo","error":"Icon_error__01Ick","success":"Icon_success__ywX2r","wait":"Icon_wait__1uDlz"};